
































































































































import { Event, SubEvent } from 'inscreva-sse-models';
import $ from 'jquery';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';
import { StepInfo, Step, FormStep, StepDetails } from '../models/step';
import { Subscription } from '../models/subscription';
import { Voucher } from '../models/voucher';
import { eventUIStore } from '../store/event-ui';
import { subscriptionStore } from '../store/subscription';
import CustomWarningComponent from './CustomWarningComponent.vue';
import DynamicConfirmation from './DynamicConfirmation.vue';
import DynamicForm from './DynamicForm.vue';
import EventHeader from './EventHeader.vue';
import EventPresentation from './EventPresentation.vue';
import Loading from './Loading.vue';
import ModalInfo from './Modal.vue';
import Stepper from './Stepper.vue';
import TalksTemplate from './templates/Talks.vue';

export type SubscriptionResponse = {
  status: 'error' | 'success';
  title: string;
  messages: Array<string | { status: string; message: string }>;
  subscription?: Subscription;
  vouchers?: Array<Voucher>;
  finalizeRegister?: boolean;
  isModalClosed?: boolean;
  cancelHandler?: () => Promise<void>;
  cancelButton?: string;
  cancelResponse?: { status: 'error' | 'success'; message: string };
};

@Component({
  components: {
    Loading,
    Stepper,
    DynamicForm,
    EventHeader,
    DynamicConfirmation,
    TalksTemplate,
    ModalInfo,
    EventPresentation,
    CustomWarningComponent,
  },
})
export default class SignUpForm extends Vue {
  @Prop({ required: true })
  eventUI: EventUI;

  currentStep = 0;

  stepOptions = {
    dots_first: true,
    show_title: true,
  };

  stepper!: Stepper;

  responseModal!: ModalInfo;

  card!: HTMLFormElement;

  response: SubscriptionResponse = null;

  async mounted() {
    this.$nextTick(() => {
      this.stepper = this.$refs.stepper as Stepper;
      this.responseModal = this.$refs.modal_info as ModalInfo;
      this.card = this.$refs.card as HTMLFormElement;
    });
  }

  private hiddenEmail(email: string): string {
    const emailParts = email.split('@');

    return `${emailParts[0].slice(0, 1)}****@${emailParts[1]}`;
  }

  private successResponse(subscription: Subscription, subscriptionFound = false): SubscriptionResponse {
    const plural = subscription.vouchers.length > 1;
    const s = plural ? 's' : '';
    const messages = [
      subscriptionFound ? 'Já existe uma inscrição com este cpf' : 'O seu cadastro foi completado com sucesso',
      `Guarde o${s} voucher${s} no seu celular para acessar o evento no dia.`,
      `*Atenção: O${s} voucher${s} est${s ? 'arão' : 'ará'} disponíve${s ? 'is' : 'l'} ${
        subscriptionFound ? 'somente' : 'também'
      } no e-mail ${this.hiddenEmail(subscription.email)}.`,
    ];

    return {
      status: 'success',
      title: 'Sucesso',
      messages,
      subscription,
      vouchers: subscriptionFound ? null : subscription.vouchers,
      finalizeRegister: !subscriptionFound,
      cancelButton: subscriptionFound && 'Reenviar',
      cancelHandler: async () => subscriptionStore.resendEmail({ subscription, alias: this.eventUI.alias }),
    };
  }

  async submit() {
    this.eventUI.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return eventUIStore
      .save(this.eventUI)
      .then(() => {
        this.response = this.successResponse(eventUIStore.eventUI.subscription);
      })
      .catch((err: any) => {
        this.response = {
          status: 'error',
          title: 'Atenção',
          messages: [`${err.message}`],
        };
      })
      .finally(() => {
        this.responseModal.open();
      });
  }

  async cancel(triggerAction?: boolean) {
    if (!this.response.cancelHandler || !triggerAction) {
      return this.close();
    }

    const cancelResponse = await this.response
      .cancelHandler()
      .then(() => ({
        status: 'success',
        message: 'E-mail reenviado com sucesso',
      }))
      .catch(() => ({
        status: 'error',
        message: 'Falha ao enviar e-mail, entre em contato conosco!',
      }));

    this.$nextTick(() => this.response.messages.push(cancelResponse));
  }

  async close() {
    this.responseModal.close();
    this.response.isModalClosed = true;
  }

  nextPrev(step: number) {
    window.location.hash = '';

    if (this.is_last_step && step === 1) {
      return this.submit();
    }

    return this.stepper.nextPrev(step);
  }

  updateCurrentStep(step: StepInfo) {
    this.currentStep = this.steps.findIndex((elm) => elm.info.identifier === step.identifier);
  }

  get steps_info(): Array<StepInfo> {
    return this.steps.map(({ info }) => info);
  }

  get steps(): Array<Step> {
    return (this.eventUI.event as Event).steps || [];
  }

  get is_last_step() {
    return this.steps.length === this.currentStep + 1;
  }

  qrCodeForVoucher(voucher: Voucher) {
    return `http://chart.apis.google.com/chart?cht=qr&chs=80x80&chl=${voucher.code}`;
  }

  favorite(eventUI: EventUI) {
    if (!this.eventUI.event.extraFormData?.favorites) {
      this.eventUI.event.extraFormData.favorites = [];
    }

    const index = this.eventUI.event.extraFormData.favorites.findIndex((elm) => elm._id === eventUI.event._id);
    const finalIndex = index !== -1 ? index : this.eventUI.event.extraFormData.favorites.length;

    this.eventUI.event.extraFormData.favorites.splice(finalIndex, 1, {
      _id: eventUI.event._id,
      info: { name: eventUI.event.info.name, price: eventUI.event.info.price },
      parent: (eventUI.event as SubEvent).parent,
    });
  }

  async searchBy(qs: any) {
    const subscription = await subscriptionStore.searchBy({ params: qs, alias: this.$route.params.alias });

    if (!subscription || (Array.isArray(subscription) && subscription.every((elm) => !elm))) {
      return;
    }

    this.response = this.successResponse(subscription, true);
    this.responseModal.open();
  }

  onSelect() {
    const hash = '#buttons';

    window.location.hash = '';
    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top,
      },
      800,
      () => {
        window.location.hash = hash;
      },
    );
  }

  get event_info_place(): string {
    if (this.isOnline) {
      return `${window.location.origin}/${this.eventUI.alias}`;
    }

    return typeof this.eventUI.event.info.place === 'string'
      ? this.eventUI.event.info.place
      : this.eventUI.event.info.place?.name || '';
  }

  get isOnline() {
    return (this.eventUI.event as Event).extraInfo.isOnline;
  }

  async redirect() {
    await this.close();
    this.$router.replace({ name: 'sign-in', params: { alias: this.eventUI.alias }, replace: true });
  }

  get event() {
    return this.eventUI.event as Event;
  }

  stepForm(step: Step) {
    return (step as FormStep).form;
  }

  stepTemplate(step: StepDetails) {
    return step.template;
  }

  isSuccessMessage(message: string | { status: string; message: string }) {
    return typeof message !== 'string' ? message.status === 'success' : false;
  }

  messageContent(message: string | { status: string; message: string }) {
    return typeof message !== 'string' ? message.message : '';
  }
}
